import React from "react";
import { brMill } from "@react-jvectormap/brazil";

// Mapa do Brasil da aba Vencedoras: cada UF do escopo pintada pela situação
// (com vencedora, sem vencedora, sem principal ou % acima de 100); fora do
// escopo fica neutra. Mesmo SVG do mapa de Frete por UF (MapFretePorUF).

const { width: MAP_W, height: MAP_H, paths } = brMill.content;

export default function MapaCoberturaUfs({ ufs, rotulos, vencedorasPorUf }) {
  const porUf = {};
  (ufs || []).forEach((u) => {
    porUf[u.uf] = u;
  });

  return (
    <svg className="bf-mapa" viewBox={`0 0 ${MAP_W} ${MAP_H}`} role="img" aria-label="Cobertura das UFs do escopo" data-testid="bf-mapa-ufs">
      {Object.entries(paths).map(([code, { path, name }]) => {
        const uf = code.toUpperCase();
        const u = porUf[uf];
        const nomes = (vencedorasPorUf && vencedorasPorUf[uf]) || [];
        const dica = u ? `${name} (${uf}): ${rotulos[u.estado] || u.estado}${nomes.length ? ` · ${nomes.join(", ")}` : ""}${u.temPercentual ? ` · ${u.soma}%` : ""}` : `${name}: fora do escopo`;
        return (
          <path key={code} d={path} className={u ? `bf-uf estado-${u.estado}` : "bf-uf-fora"} data-uf={u ? uf : undefined} data-estado={u ? u.estado : undefined}>
            <title>{dica}</title>
          </path>
        );
      })}
    </svg>
  );
}
